import React from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { Skeleton } from "../../../../atoms/skeleton";
import { Status } from "../../../../atoms/status";
import { formattedDateTime } from "../../../../../utils";
import {
  useSaasToolUserGroupListQuery,
  useSingleSaasToolQuery,
} from "../../../../../store/saasTool/saasToolSlice";
import { DataTable } from "../../../../organisms/dataTable";
import { PAGE_NAME } from "../../../../../constants/constants";

const MergeBaseUserDetails = () => {
  const pageClassName = "p-mergeBaseUserDetails";

  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useSingleSaasToolQuery({ id });

  const projectTableHeader = [
    {
      title: "Serial",
      dataIndex: "id",
      isSortable: true,
    },
    {
      title: "Name",
      dataIndex: "groupName",
      isSortable: true,
    },
    {
      title: "Role",
      dataIndex: "groupRole",
      isSortable: true,
    },
  ];

  return (
    <div className={pageClassName}>
      <Breadcrumb />
      <p className={`${pageClassName}__title`}>{PAGE_NAME.MERGEBASE_USER_INFO}</p>
      <div className={`${pageClassName}__container`}>
        <div className={`${pageClassName}__container__item`}>
          <p className={`${pageClassName}__container__item__title`}>
            First Name
          </p>
          <p className={`${pageClassName}__container__item__value`}>
            {isLoading ? (
              <Skeleton height="small" />
            ) : (
              data?.result?.oktaUser?.firstName ?? "-"
            )}
          </p>
        </div>
        <div className={`${pageClassName}__container__item`}>
          <p className={`${pageClassName}__container__item__title`}>
            Last Name
          </p>
          <p className={`${pageClassName}__container__item__value`}>
            {isLoading ? (
              <Skeleton height="small" />
            ) : (
              data?.result?.oktaUser?.lastName ?? "-"
            )}
          </p>
        </div>
        <div className={`${pageClassName}__container__item`}>
          <p className={`${pageClassName}__container__item__title`}>Email</p>
          <p className={`${pageClassName}__container__item__value`}>
            {isLoading ? (
              <Skeleton height="small" />
            ) : data?.result?.oktaUser?.email ? (
              data?.result?.oktaUser?.email
            ) : (
              data?.result?.email
            )}
          </p>
        </div>

        <div className={`${pageClassName}__container__item`}>
          <p className={`${pageClassName}__container__item__title`}>Status</p>
          {isLoading ? (
            <Skeleton height="small" />
          ) : (
            <Status status={data?.result?.status} />
          )}
        </div>

        <div className={`${pageClassName}__container__item`}>
          <p className={`${pageClassName}__container__item__title`}>Created</p>
          <p className={`${pageClassName}__container__item__value`}>
            {isLoading ? (
              <Skeleton height="small" />
            ) : (
              data?.result?.oktaUser?.created ? (
                formattedDateTime(data?.result?.created)
              ) : (
                "-"
              )
            )}
          </p>
        </div>

        <DataTable
          title="Dashboards"
          id={id as string}
          toolName="MergeBase"
          tableHeader={projectTableHeader}
          useCallApiQuery={useSaasToolUserGroupListQuery}
        />
      </div>
    </div>
  );
};

export default MergeBaseUserDetails;
